import React, { useState, useEffect, useRef } from 'react'
import { useLanguage } from '../context/LanguageContext'

const LanguageSelector = () => {
  const { language, changeLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const selectorRef = useRef(null);

  const languages = [
    { code: 'en', label: 'English', flag: 'GB' },
    { code: 'fr', label: 'Français', flag: 'FR' }
  ];

  const currentLang = languages.find(lang => lang.code === language);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const selectLanguage = (code) => {
    changeLanguage(code);
    setIsOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectorRef.current && !selectorRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="floating-language-selector" ref={selectorRef}>
      <button 
        className="language-selector-button"
        onClick={toggleDropdown}
        aria-label="Select Language"
      >
        {/* <span className="flag">{currentLang?.flag}</span> */}
        <span className="lang-code">{currentLang?.code.toUpperCase()}</span>
        <svg 
          className={`arrow ${isOpen ? 'open' : ''}`}
          width="12" 
          height="8" 
          viewBox="0 0 12 8" 
          fill="none"
        >
          <path d="M1 1L6 6L11 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      </button>
      
      {isOpen && (
        <div className="language-dropdown-menu">
          {languages.map((lang) => (
            <button
              key={lang.code}
              className={`language-option ${language === lang.code ? 'active' : ''}`}
              onClick={() => selectLanguage(lang.code)}
            >
              {/* <span className="flag">{lang.flag}</span> */}
              <span className="lang-label">{lang.label}</span>
              {language === lang.code && (
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M13 4L6 11L3 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}

export default LanguageSelector
